import Axios from 'axios';
import apiClient from './client';

export const customInstance = <T>(
  url: string,
  config?: RequestInit,
): Promise<T> => {
  const source = Axios.CancelToken.source();
  const promise = apiClient({
    url,
    method: config?.method as string,
    data: config?.body,
    headers: config?.headers as Record<string, string>,
    cancelToken: source.token,
    signal: config?.signal as AbortSignal,
  }).then(({ data, status, headers }) => (({
    data,
    status,
    headers
  }) as T));

  // @ts-expect-error - Adding cancel method to promise for React Query cancellation
  promise.cancel = () => {
    source.cancel('Query was cancelled');
  };

  return promise;
};

export default customInstance;
